<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.sites')}`">
              <div class="v-table">
                <TableServer type="sites" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-site')}`">
              <SiteForm v-if="spawnerAdminSchemas.forms['Site']" />
            </b-tab>
            <b-tab
              v-if="siteId !== null && adminSite.id > 0"
              :title="`${this.$i18n.t('JSON.site')}#${siteId}`"
            >
              <SiteForm
                v-if="spawnerAdminSchemas.forms['Site']"
                :site="adminSite"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    SiteForm: () => import('@/components/admin/spawner/modals/forms/SiteForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    siteId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      adminSite: (state) => state.adminSite.adminSite,
    }),

    modalId() {
      return 'site';
    },
  },

  watch: {
    siteId(newValue) {
      if (newValue !== null) {
        this.loadSpawnerAdminSite();
      }
    },
  },

  methods: {
    ...mapActions(['getSpawnerAdminSite']),

    async loadSpawnerAdminSite() {
      try {
        await this.getSpawnerAdminSite({
          params: {
            tid: this.siteId,
          },
        });

        // console.log('site', this.site);

        // success
        // console.log('success loading site!');
      } catch (error) {
        // error
        // console.log('error loading site!');
      }
    },

    onOpened() {
      if (this.siteId !== null) {
        this.loadSpawnerAdminSite();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
